import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'followup-template',
  templateUrl: './followup-template.component.html',
  styleUrls: ['../../../meeting-form.component.scss']
})
export class FollowupTemplateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
